module.exports = __webpack_public_path__ + "img/communication-and-multimedia-info.9a425fec.svg";